import React, { FC } from "react";
import { Button } from "../../Form/Button";
import "./NothingToSave.css";
import { CloseButton } from "../../Form/CloseButton";

interface NothingToSaveInterface {
  onClose?(): void;
}

export const NothingToSave: FC<NothingToSaveInterface> = props => {

  return (
    <div>
      <div className="NothingToSave Add_Crew">
        <div className="New_Crew_Title">
          <div>Nothing To Save</div>
          <CloseButton onClick={() => props.onClose?.()} />
        </div>
        <div className="ErrorMessage">
          <div className="ErrorSign">
            <div className="Arrow1"></div>
            <div className="Arrow2"></div>
          </div>
          <div className="ErrorText">
            No Data entered for curent period. Review your schedule.
          </div>
        </div>
        <div className="ErrorActionHolder">
          <Button
            onClick={() => props.onClose?.()}
            title="OK"
            type="button"
            className="Button"
          />
        </div>
      </div>
    </div>
  );
}